<template>
	<admin-base-layout>
		<template slot="admin-page-header">
			<h3 class="page-header">Generate Token</h3>
		</template>

		<template slot="admin-page-content">
			<div class="admin-page-content">
				<create-token :showExpiration="true"></create-token>
			</div>
		</template>
	</admin-base-layout>
</template>

<script>
const router = require("@/router");

export default {};
</script>

<style scoped>
h3 {
  margin: 0;
  padding: 0;
  border: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/GenerateToken.vue